import { render, staticRenderFns } from "./SearchResultTabsAllNoData.vue?vue&type=template&id=ba6be278&scoped=true&"
import script from "./SearchResultTabsAllNoData.vue?vue&type=script&lang=js&"
export * from "./SearchResultTabsAllNoData.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultTabsAllNoData.vue?vue&type=style&index=0&id=ba6be278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6be278",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
